import { compile, ParseOptions, PathFunctionOptions } from 'path-to-regexp';
import { stringify } from 'query-string';
import { isNilOrEmpty } from '~common/helper/global';

export { parse, stringify } from 'query-string';
export { compile, ParseOptions } from 'path-to-regexp';

export type PathFunction<P> = (data: P, options?: PathFunctionOptions) => string;

export type QueryPathFunction<P, Q> = (
  data?: P,
  query?: Q,
  options?: PathFunctionOptions,
) => string;

/***
 * @deprecated use compilePath instead
 */
export const compileWithArgs = <P = {}>(path: string, options?: ParseOptions): PathFunction<P> =>
  compile(path, options);

const addQuestionMark = (queryString?: string): string =>
  isNilOrEmpty(queryString) ? '' : `?${queryString}`;

/***
 * @deprecated use compilePath instead
 */
export const compileWithParams = <P = {}, Q = {}>(
  path: string,
  options?: ParseOptions,
): QueryPathFunction<P, Q> => (data?: P, query?: Q): string => {
  const stringified = stringify(query);
  return compile(path, options)(data) + addQuestionMark(stringified);
};

export interface LinkConfig<P, Q extends {}> {
  urlParams?: P;
  queryParams?: Q | string;
}

export type CompileConfigType<P = {}, Q = {}, C extends LinkConfig<P, Q> = {}> = (
  config?: C,
) => string;

//This does not support nested json as query params. If you need it, the caller should call passing JSON.stringify (or handle as needed)
export const compilePath = <P = {}, Q = {}>(
  path: string,
  options?: ParseOptions,
): CompileConfigType<P, Q> => (config: LinkConfig<P, Q> = {}): string => {
  let queryParams = '';
  if (!isNilOrEmpty(config.queryParams)) {
    if (typeof config.queryParams === 'string') {
      queryParams = config.queryParams;
    } else {
      queryParams = addQuestionMark(stringify(config.queryParams));
    }
  }

  return `${compile(path, options)(config.urlParams)}${queryParams}`;
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/route/path-to-regexp.ts